// MIT License - Copyright (c) 2026 Doug McNall
// Site Configuration
// Centralized configuration for business logic and site settings

export const siteConfig = {
  // Business Logic
  business: {
    taxRate: parseFloat(process.env.REACT_APP_TAX_RATE) || 0.08, // 8% tax default
    shippingCost: parseFloat(process.env.REACT_APP_SHIPPING_COST) || 5.99,
    freeShippingThreshold: parseFloat(process.env.REACT_APP_FREE_SHIPPING_THRESHOLD) || 50.00,
  },

  // Contact Information
  contact: {
    email: process.env.REACT_APP_CONTACT_EMAIL || 'support@ddhotsauce.com',
    phone: process.env.REACT_APP_CONTACT_PHONE || '1-800-HOT-SAUCE',
    phoneDisplay: process.env.REACT_APP_CONTACT_PHONE_DISPLAY || '1-800-HOT-SAUCE',
  },

  // Company Information
  company: {
    name: process.env.REACT_APP_COMPANY_NAME || 'D&D Hot Sauce',
    tagline: process.env.REACT_APP_COMPANY_TAGLINE || 'All things spicy for people who are all about flavor',
  },

  // Social Media
  social: {
    pinterest: process.env.REACT_APP_SOCIAL_PINTEREST || 'https://pinterest.com/ddhotsauce',
    instagram: process.env.REACT_APP_SOCIAL_INSTAGRAM || 'https://instagram.com/ddhotsauce',
    facebook: process.env.REACT_APP_SOCIAL_FACEBOOK || 'https://facebook.com/ddhotsauce',
    twitter: process.env.REACT_APP_SOCIAL_TWITTER || 'https://twitter.com/ddhotsauce',
  },

  // Heat Level Labels
  heatLevels: {
    0: '',
    1: 'Mild',
    2: 'Medium',
    3: 'Hot',
    4: 'Very Hot',
    5: 'Extreme',
  },
};

export default siteConfig;
